import { Size } from '../designConstants';

export const CONTROL_SIZES = {
  [Size.SM]: 'sm',
  [Size.MD]: undefined,
  [Size.LG]: 'lg'
} as const;
